export const APP_NAME = "Calibrate";
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
export const PRIVACY_POLICY_URL = "https://calibratehcm.com/privacy-policy";
export const TERMS_OF_SERVICE_URL = "https://calibratehcm.com/terms-and-conditions";
export const LOGO_URL = "/images/logo.png";